import { render } from "./social_links.vue?vue&type=template&id=00eb3bc0"
import script from "./social_links.vue?vue&type=script&lang=js"
export * from "./social_links.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__